"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalMountTarget = void 0;
var react_1 = __importStar(require("react"));
var ModalStore_1 = __importDefault(require("./ModalStore"));
function ModalMountTarget(props) {
    var store = props.store;
    var _a = react_1.useState([]), items = _a[0], setItems = _a[1];
    react_1.useEffect(function () {
        var unsubstribe = store.subscribe(function (s) { return setItems(s.items); });
        return function () { return unsubstribe(); };
    }, [store]);
    return (react_1.default.createElement("div", null, items.map(function (item) { return (react_1.default.createElement(react_1.default.Fragment, { key: item.key }, item.component)); })));
}
exports.ModalMountTarget = ModalMountTarget;
ModalMountTarget.defaultProps = {
    store: ModalStore_1.default,
};
//# sourceMappingURL=ModalMountTarget.js.map